/**
 * Shared heading + description for directory / tab pages (Shops / Orgs /
 * Favorites / Scan via JourneyShell). Favorites title scale is the baseline:
 * text-2xl / space-y-1 / px-0.5.
 */

export interface DirectoryPageHeaderProps {
  readonly title: string;
  readonly description: string;
  readonly titleAs?: 'h1' | 'h2';
  readonly className?: string;
  readonly testId?: string;
}

export function DirectoryPageHeader({
  title,
  description,
  titleAs = 'h1',
  className,
  testId = 'directory-page-header',
}: DirectoryPageHeaderProps): JSX.Element {
  const TitleTag = titleAs;
  const hasTitle = title.length > 0;
  const hasDescription = description.length > 0;

  return (
    <header
      className={['shrink-0 space-y-1 px-0.5', className].filter(Boolean).join(' ')}
      data-testid={testId}
    >
      {hasTitle ? (
        <TitleTag className="text-2xl font-semibold tracking-tight text-[var(--color-on-surface)]">
          {title}
        </TitleTag>
      ) : null}
      {hasDescription ? (
        <p className="text-sm leading-snug text-[var(--color-on-surface-muted)]">
          {description}
        </p>
      ) : null}
    </header>
  );
}
